import React from "react"
import { useRoutes } from "react-router-dom"
import 'rsuite/dist/rsuite-no-reset.min.css'
import 'react-multi-carousel/lib/styles.css'

import routes from "./Routes"
import AppTheme from "./Theme"
import { userData, username } from '@signals'
import { SupportChatLoader } from "Layout/SupportChat"


export default function App() {
	const elements = useRoutes(routes(userData.value))

	return <AppTheme>
		{elements}
		<SupportChatLoader name={username.value}/>
	</AppTheme>
}